import React, { useState, useEffect } from 'react'
import { ActionButton } from '@emerald-works-nova/components'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { Box, Divider, Grid, Switch, Typography, useTheme } from '@mui/material'
import { useDispatch } from 'react-redux'
import { BannerStatic } from '../../../components'
import { TenantEditSlice } from '../../../reducers'
import { useStyles } from '../features-tab/style'
import { useTenantFormContext } from '../tenant-form-context'
import { Controller } from 'react-hook-form'

const AccelerateSettings = () => {
  const classes = useStyles()
  const { spacing } = useTheme()
  const dispatch = useDispatch()
  const { tenant, isEdit, form } = useTenantFormContext()
  const { watch, setValue } = form
  const [isLoading, setIsLoading] = useState(false)
  const features = watch('features')
  const accelerate = features?.accelerate?.enabled ?? false
  const msb = features?.msb ?? false
  const assessment = features?.assessment?.enabled ?? false

  const handleSwitch = () => {
    setValue('features.accelerate.enabled', !accelerate)
  }

  useEffect(() => {
    if (!isEdit) {
      setValue('features.accelerate.enabled', false)
      return
    }
    const hasAccelerate = tenant?.features?.accelerate?.enabled ?? false
    setValue('features.accelerate.enabled', hasAccelerate)
  }, [tenant, isEdit, setValue])

  const [tenantUpdate] = useEvent([
    {
      eventName: 'tenantUpdate',
      onSuccess: (tenant) => {
        BannerStatic.show({ label: 'Accelerate configuration updated' })
        setIsLoading(false)
        dispatch(TenantEditSlice.actions.updateTenantFeatures(tenant.features))
      },
      onError: (error) => {
        console.error('tenantUpdate', error)
        BannerStatic.show({
          label: 'There was an error saving the Accelerate configuration',
          isError: true
        })
        setIsLoading(false)
      }
    }
  ])

  const handleSave = () => {
    if (!assessment && accelerate) {
      return BannerStatic.show({
        label: 'You need to enable Manager Skills Assessment first',
        isWarning: true
      })
    }
    if (!msb && accelerate) {
      return BannerStatic.show({
        label: 'You need to enable Manager Skills Builder first',
        isWarning: true
      })
    }

    tenantUpdate.trigger({
      pk: tenant.pk,
      features: {
        ...tenant.features,
        accelerate: {
          enabled: accelerate
        }
      }
    })
    setIsLoading(true)
  }

  return (
    <Grid container className={classes.featContainer}>
      <Grid item xs={12}>
        <Box
          border={1}
          borderRadius='undefinedpx'
          borderColor='#E0E0E0'
          display='flex'
          style={{
            justifyContent: 'space-between',
            flexDirection: 'column',
            padding: spacing(1, 4)
          }}
        >
          <Box display='flex' flexDirection='row'>
            <Typography variant='body2' style={{ marginTop: spacing(3.5) }}>
              Accelerate
            </Typography>
            <Box
              display='flex'
              style={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                flex: 1,
                padding: spacing(1)
              }}
            >
              <Box style={{ padding: spacing(2, 0.5) }}>
                <Controller
                  name='features.accelerate.enabled'
                  control={form.control}
                  render={({ field }) =>
                    <Switch
                      color='primary'
                      checked={!!field.value}
                      onChange={handleSwitch}
                      disabled={isLoading}
                      data-test='accelerate-product-toggle'
                    />}
                />
              </Box>
            </Box>
          </Box>

          {isEdit && (
            <Box>
              <Divider style={{ marginBottom: spacing(1) }} />

              <Box display='flex' justifyContent='flex-end' mt={1} mb={1}>
                <ActionButton
                  onClick={handleSave}
                  disabled={isLoading}
                  variant='primary'
                  dataTest='accelerate-save-button'
                  style={{ height: 'min-content' }}
                > Save
                </ActionButton>
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  )
}

export default AccelerateSettings
